import apiClient from '../helpers/apiClient'

export async function refreshToken (token) {
  return await apiClient.post(process.env.REACT_APP_CONFIRMATION_API + 'auth/refresh', { token })
}

export async function refreshProactiveToken (token) {
  return await apiClient.post(process.env.REACT_APP_CONFIRMATION_API + 'auth/refresh-proactive', { token })
}
